
// Optimized plan selection: observer + minimal retry
let __legacyPendingGroup = null;
let __legacySelecting = false;
const LEGACY_MAX_WAIT = 8000; // ms
const dbg = (...a) => { if (window.__LEGACY_TOGGLES_DEBUG__) console.log('[legacy-toggles]', ...a); };

function selectPlanGroup(group){
  if(!group) return;
  __legacyPendingGroup = group; // always keep last requested
  if(__legacySelecting) return; // selection cycle already running
  __legacySelecting = true;
  const started = performance.now();

  const attempt = () => {
    const container = document.querySelector(`.sls-option-container[data-selling-plan-group="${__legacyPendingGroup}"]`);
    if(!container) return false;
    const input = container.querySelector('input[type="checkbox"],input[type="radio"]');
    // Sometimes widget uses label/select; try clicking label if no input yet
    if(input){
      if(!input.checked){
        input.checked = true;
        input.dispatchEvent(new Event('change', { bubbles:true }));
        dbg('selected group via input', __legacyPendingGroup);
      }
    } else {
      const label = container.querySelector('label, .sls-selling-plan-group-name');
      if(label){ label.click(); dbg('clicked label fallback', __legacyPendingGroup); }
    }
    return true;
  };

  if(attempt()) { __legacySelecting = false; return; }

  const observer = new MutationObserver(() => {
    if(attempt()){ observer.disconnect(); clearInterval(interval); __legacySelecting = false; }
  });
  try { observer.observe(document.body, { childList:true, subtree:true }); } catch{}

  const interval = setInterval(() => {
    if(attempt()){ observer.disconnect(); clearInterval(interval); __legacySelecting = false; return; }
    if(performance.now() - started > LEGACY_MAX_WAIT){
      dbg('timeout selecting group', __legacyPendingGroup);
      observer.disconnect(); clearInterval(interval); __legacySelecting = false; }
  }, 350);
}

function initActive() {
  const toggleButtons = document.querySelectorAll('.toggle-option');
  if(!toggleButtons.length){
    if (window.location.pathname.includes('/search') || window.location.search.includes('q=')) {
      selectPlanGroup(1);
    }
    return;
  }

  toggleButtons.forEach(button => {
    if(button._legacyBound) return; // prevent double binding
    button._legacyBound = true;
    button.addEventListener('click', function(){
      const parentGroup = this.closest('.billing-toggle');
      if(parentGroup){ parentGroup.querySelectorAll('.toggle-option').forEach(btn => btn.classList.remove('active')); }
      this.classList.add('active');
      const group = this.dataset.planGroup;
      selectPlanGroup(group);
    });
  });

  // Apply initial active
  const preActive = Array.from(toggleButtons).find(b => b.classList.contains('active'));
  if(preActive){ selectPlanGroup(preActive.dataset.planGroup); }
}

(function(){
  // Guard flags so this file doesn't conflict with pricing-tabs.js dynamic system
  const isPricingTabsEnv = () => !!window.__PRICING_TABS_ENV__;
  // Wrap original functions with environment checks
  const _origInitActive = typeof initActive === 'function' ? initActive : null;

  // Replace only if originals exist (they do later in file after hoisting)
  if (typeof window !== 'undefined') {

    window.initActive = function(){
      if (isPricingTabsEnv() && (window.location.pathname.includes('/pages/pricing') || window.location.search.includes('tab='))) {
        return; // skip on pricing page
      }
      return _origInitActive && _origInitActive.apply(this, arguments);
    };

  }

  // Intercept DOMContentLoaded listener logic: Delay adding our own if pricing tabs present
  document.addEventListener('DOMContentLoaded', () => {
    if (isPricingTabsEnv() && (window.location.pathname.includes('/pages/pricing') || window.location.search.includes('tab='))) {
      // Skip automatic init; pricing-tabs.js will manage everything on pricing page
      return;
    }
    // Run original initialization sequence (functions already wrapped)
    try { initActive(); } catch(e) {}
  });
})();

document.addEventListener("DOMContentLoaded", function () {
  const MAX_QTY = 25;
  // Classify selling plan option containers (annual / monthly) outside pricing-tabs environment
  const classifyPlanOptions = (root=document) => {
    root.querySelectorAll('.sls-option-container').forEach(opt => {
      const nameTxt = (opt.querySelector('.sls-selling-plan-group-name')?.textContent || '').toLowerCase();
      // Reset to avoid duplicate / stale classification
      opt.classList.remove('annual','monthly');
      if(/annual|year/.test(nameTxt)) {
        opt.classList.add('annual');
      } else if(/month|monthly|mo\b/.test(nameTxt)) { // support both 'monthy' typo and 'monthly'
        opt.classList.add('monthly');
      }
    });
  };
  classifyPlanOptions();

  // Map toggle buttons (Monthly / Annual) to actual Seal selling plan group IDs
  const mapSealTogglesToOptions = () => {
    const toggleWrap = document.querySelector('.billing-toggle');
    if(!toggleWrap) return false;
    const toggles = Array.from(toggleWrap.querySelectorAll('.toggle-option'));
    if(!toggles.length) return false;
    const options = Array.from(document.querySelectorAll('.sls-option-container[data-selling-plan-group]'));
    if(!options.length) return false;
    // Build index by interval classification
    const annualOpt = options.find(o => o.classList.contains('annual'));
    const monthlyOpt = options.find(o => o.classList.contains('monthly'));
    // Assign dataset.planGroup using textual heuristics
    toggles.forEach(btn => {
      const txt = (btn.textContent || '').toLowerCase();
      let target = null;
      if(/annual|year/.test(txt)) target = annualOpt;
      else if(/month|monthly|mo\b/.test(txt)) target = monthlyOpt;
      if(target){
        const id = target.getAttribute('data-selling-plan-group');
        if(id) btn.dataset.planGroup = id;
      }
    });
    // If currently active button has remapped id, re-select
    const active = toggles.find(b => b.classList.contains('active'));
    if(active && active.dataset.planGroup){
      selectPlanGroup(active.dataset.planGroup);
    } else {
      // Prefer annual as default if present
      const prefer = toggles.find(b => /annual|year/.test((b.textContent||'').toLowerCase())) || toggles[0];
      if(prefer){
        toggles.forEach(b => b.classList.remove('active'));
        prefer.classList.add('active');
        if(prefer.dataset.planGroup) selectPlanGroup(prefer.dataset.planGroup);
      }
    }
    return true;
  };
  // Initial mapping attempt (may fail if Seal not injected yet)
  mapSealTogglesToOptions();
  // Observe late injections of Seal subscription widget options
  const optObserver = new MutationObserver(muts => {
    let changed = false;
    muts.forEach(m => m.addedNodes.forEach(n => {
      if(n.nodeType!==1) return;
      if(n.matches?.('.sls-option-container')) { changed = true; return; }
      if(n.querySelector?.('.sls-option-container')) { changed = true; }
    }));
    if(changed) classifyPlanOptions();
    if(changed) mapSealTogglesToOptions();
  });
  try { optObserver.observe(document.body, { childList:true, subtree:true }); } catch {}
  document.addEventListener("bundler:bundle_widget_created", function (e) {
    const productsObj = e.detail?.products || {};
    const products = Object.values(productsObj);
    products.forEach(product => {
      if (product.handle === "rio-router") {
        const input = document.querySelector(
          `.bndlr-add-to-cart-quantity-input`
        );
        if (input) {
          input.addEventListener("input", function () {
            let val = parseInt(this.value, 10);
            let warningMessage = "";
            if (val > MAX_QTY) {
              this.value = MAX_QTY;
               warningMessage = "You can only add "+MAX_QTY+" routers";
            }
            document.querySelector('.bndlr-bundle-checkout-warning').textContent = warningMessage;
          });
        }
        // Thêm label Onetime purchase ngay dưới tiêu đề router (chỉ thêm một lần)
        const routerTitle = document.querySelector('.bndlr-product[data-product-id="'+product.id+'"] .bndlr-product-title, .bndlr-product-title[title*="Router"]');
        if (routerTitle && !routerTitle.parentElement.querySelector('.bndlr-onetime-label')) {
          const lbl = document.createElement('div');
          lbl.className = 'bndlr-onetime-label';
          lbl.textContent = 'Onetime purchase';
          routerTitle.insertAdjacentElement('afterend', lbl);
        }
    }
  });});
});


